// Чувствительные параметры в ссылках — не для аналитики (MOB-470, болезнь 1 эпика
// ANALYTICS-CONTRACT). Ссылки баннеров и т. п. несут token / deep_link_sub1 (JWT),
// _uah и идентичность посетителя (_ac_cid, _ac_ref); переходу они нужны, а в событие
// попадать не должны. Список имён — общий с MOB-586 (SENSITIVE_URL_PARAMS);
// здесь — более широкое сопоставление: регистр, &amp;, начало hash, URL-кодирование.
// stripUrlToken чистит адресную строку, а это — значения параметров событий.
import { SENSITIVE_URL_PARAMS } from '@web/common/url'

const KEY = `(?:${SENSITIVE_URL_PARAMS.map(name => name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`
// Значение не захватывает пробел: свободный текст после ссылки остаётся.
const VALUE = '[^&#\\s]*'
// Во вложенной URL-кодированной ссылке значение тянется до %26 / & / # / пробела.
const ENCODED_VALUE = '(?:(?!%26)[^&#\\s])*'

// Параметр сразу после ? или # (или %3F): начало сохраняем, если за ним идут
// другие параметры, — тогда съедаем следующий разделитель; иначе убираем и начало.
const FIRST_PARAM = new RegExp(`([?#])${KEY}=${VALUE}(&amp;|&)?`, 'gi')
const NEXT_PARAM = new RegExp(`(?:&amp;|&)${KEY}=${VALUE}`, 'gi')
const FIRST_ENCODED = new RegExp(`(%3F)${KEY}%3D${ENCODED_VALUE}(%26)?`, 'gi')
const NEXT_ENCODED = new RegExp(`%26${KEY}%3D${ENCODED_VALUE}`, 'gi')
const HAS_AUTH_PARAM = new RegExp(`(?:[?#&;]|%3F|%26)${KEY}(?:=|%3D)`, 'i')

function keepStart (_match: string, start: string, separator?: string): string {
  return separator ? start : ''
}

// Принимает любое значение: старые события собираются и из JS, где в «строковом»
// поле может оказаться число или undefined, — такие значения возвращаются как есть.
export function stripAuthParams<T> (value: T): T {
  if (typeof value !== 'string' || !HAS_AUTH_PARAM.test(value)) return value
  return value
    // Сначала параметры после разделителя, потом первый: иначе у пары
    // ?token=…&_uah=… второй после удаления первого остался бы без разделителя.
    .replace(NEXT_ENCODED, '')
    .replace(FIRST_ENCODED, keepStart)
    .replace(NEXT_PARAM, '')
    .replace(FIRST_PARAM, keepStart) as T
}
